import React, { useEffect } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import { connect } from "react-redux";
import CourseCard from "components/widget/CourseCard";
import { 
	getTrainingClassList, 
	doTrainingClassDelete,
	doTrainingClassReset,
} from "../../../../../redux/trainingclass/trainingClassState";
import dayjs from "dayjs";
import { LucideBookOpen } from "lucide-react";



const BrowseTrainingTable = ({
	recordList, 
	pagination, 
	doSearch, 
	user,

}) => {

useEffect(() => {
doSearch({ paginate: pagination?.per_page, client_id: 4 });
}, [doSearch, pagination?.per_page, user.id]);
  	
const formatSchedule = (from, to) => {
		if (!from || !to) return "No schedule available";
		return `${dayjs(from).format("MMM DD, YYYY")} → ${dayjs(to).format("MMM DD, YYYY")}`;
	};

return (
	<HeaderComponent
		title="Browse Training	"
		description="Explore available courses and programs"
		bgcolor=""
		labelIcon={<LucideBookOpen size={20} />}
	>
			<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-4" >
					{recordList && recordList.length > 0 ? (
						recordList.map((item) => (
							<CourseCard
								key={item.tcl_id}
								classTitle={item.tcl_title}
								schedule={formatSchedule(item.tcl_schedule_date_from, item.tcl_schedule_date_to)}
								/>
						))
					) : (
						<p className="text-gray-500 text-center col-span-full">
							No available classes found.
						</p>
					)}
			</div>
	</HeaderComponent>

  );
};


const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassList?.items,
	pagination: state.trainingClass.trainingClassList?.pagination,
	filters: state.trainingClass.trainingClassList?.filters,
	requesting: state.trainingClass.trainingClassList?.requesting,
	error: state.trainingClass.trainingClassList?.error,
	user: state.auth.user,

});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseTrainingTable);
